<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="content">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1 class="title">二白操作指南</h1>
      <p class="subtitle">学习如何使用二白的各种功能</p>
    </div>

    <!-- 视频容器 -->
    <div class="video_List">
      <div class="video_item" v-for="(item, index) in videoList" :key="index">
        <div class="title">{{ index + 1 + "." }}{{ item.title }}</div>
        <div class="video-container">
          <div class="video-wrapper">
            <!-- 这里使用占位视频，实际项目中应替换为真实视频链接 -->
            <video
              class="video-player"
              :poster="item.img"
              controls
              :autoplay="false"
              muted
              loop
            >
              <source :src="item.video" type="video/mp4" />
              您的浏览器不支持 HTML5 视频。
            </video>
          </div>
        </div>
      </div>
    </div>
    <!-- 视频描述 -->
    <div class="video-description">
      <div class="desc-item">
        <div class="desc-text">
          <h3>点击播放视频</h3>
          <p>观看完整的二白操作指南，了解所有功能的使用方法</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "userManual_h5",
  data() {
    return {
      videoList: [
        {
          title: "上手指南",
          video:
            "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/question/shuoming.mp4",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/question/shuoming_img.jpg",
        },
        {
          title: "配网教程",
          video:
            "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/question/shuoming1.mp4",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/question/shuoming_img1.jpg",
        },
        {
          title: "绑定与认主",
          video:
            "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/question/shuoming2.mp4",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/question/shuoming_img2.jpg",
        },
        {
          title: "背包介绍与复位介绍",
          video:
            "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/question/shuoming3.mp4",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/question/shuoming_img3.jpg",
        },
        {
          title: "小程序基础操作",
          video:
            "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/question/shuoming4.mp4",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/question/shuoming_img4.jpg",
        },
      ],
    }
  },
  methods: {
    // 处理子组件事件
    handleChildEvent(event) {
      // 根据需要处理事件
      console.log("Received event from header:", event)
    },
  },
}
</script>

<style lang="scss" scoped>
// 变量定义
$primary-bg: #020206;
$text-primary: #ffffff;
$text-secondary: #878788;
$border-radius: 20px;
$border-radius-sm: 12px;
$padding: 20px;
$shadow: 0 8px 32px rgba(0, 0, 0, 0.4);

// 混入定义
@mixin flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

@mixin box-sizing {
  box-sizing: border-box;
}

@mixin gradient-text($direction: 180deg, $start: #ffffff, $end: #d06436) {
  background: linear-gradient($direction, $start 0%, $end 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

// 全局样式重置
* {
  @include box-sizing;
  margin: 0;
  padding: 0;
}

.content {
  width: 100%;
  min-height: 100vh;
  background-color: $primary-bg;
  color: $text-primary;
  padding-bottom: 40px;

  // 页面头部
  .page-header {
    width: 100%;
    padding: 40px $padding 20px;
    text-align: center;

    .title {
      font-size: 2rem;
      font-weight: bold;
      @include gradient-text;
      margin-bottom: 10px;
    }

    .subtitle {
      font-size: 1rem;
      color: $text-secondary;
    }
  }
  .video_List {
    .video_item {
      .title {
        text-align: left;
        padding-left: 30px;
      }
    }
  }
  // 视频容器
  .video-container {
    width: 100%;
    padding: $padding;

    .video-wrapper {
      width: 100%;
      border-radius: $border-radius;
      overflow: hidden;
      box-shadow: $shadow;
      margin-bottom: 30px;
      background-color: #000;

      .video-player {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }
}
// 视频描述
.video-description {
  margin: 0 30px;
  box-sizing: border-box;
  padding: $padding;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.05) 0%,
    rgba(255, 255, 255, 0.02) 100%
  );
  border-radius: $border-radius;
  border: 1px solid rgba(255, 255, 255, 0.1);

  .desc-item {
    display: flex;
    align-items: flex-start;
    gap: 15px;

    .desc-text {
      flex: 1;

      h3 {
        font-size: 1.25rem;
        font-weight: bold;
        margin-bottom: 8px;
        color: $text-primary;
      }

      p {
        font-size: 0.875rem;
        color: $text-secondary;
        line-height: 1.6;
        text-align: left;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .content {
    .page-header {
      .title {
        font-size: 1.5rem;
      }
    }

    .video-container {
      .video-wrapper {
        margin-bottom: 20px;
      }

      .video-description {
        padding: 15px;
      }
    }
  }
}
</style>
